/* global $ */
//const fullpage = require("fullPage.js");

export default () => {
    if (!mobile)
    {
        var triggerPos = $('#timeline').offset();
        var eleWidth  = $('.pb-timeline header').width();
        console.log(triggerPos);
        var body = document.body,
        html = document.documentElement;

        var heightDoc = Math.max( body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight );



        
        window.addEventListener('resize', function()
        {
            heightDoc = Math.max( body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight );
            triggerPos = $('#timeline').offset();
            eleWidth  = $('.pb-timeline header').width();
        });
        
        $(window).scroll(function () {                        
            fixElem();
        });      

        function fixElem()
        {
            if (window.scrollY > ( triggerPos.top  + $('#timeline').height() - $('.pb-timeline header').height() - 100))
            {
                $('.pb-timeline header').removeClass('scrolled').css('width', 'auto');
            } 
            else if (window.scrollY > (triggerPos.top - 50))
            {
                $('.pb-timeline header').addClass('scrolled').css('width', eleWidth + 'px');
            } 
            else
            {
                $('.pb-timeline header').removeClass('scrolled').css('width', 'auto');
            }
        }

        fixElem();
    /*
        if (typeof IntersectionObserver != "undefined") {
            var initScroll = function(entries, observer) {
                entries.forEach(function(element, index, array) {
                    if (element.isIntersecting) {
                        console.log(element);
                        console.log($(element).offset());
                    }
                });
            };

            var observer = new IntersectionObserver(initScroll);

            observer.observe(document.getElementById("timeline"));
            
        } 
        */
    }
};